import Chooser from './chooser'

export default {

    props: {

        /**
         * @type {number|string|{}}
         */
        value: {
            type: [ Number, String ],
            default: '',
        },
    },

    data() {
        return {
            innerValue: this.value,
        }
    },

    computed: {

        options() {
            return [ ]
        },
    },

    watch: {

        value(newValue) {
            this.innerValue = newValue
        },
    },

    methods: {

        onInput(value) {
            this.innerValue = value
            this.$emit('input', value)
        },
    },

    components: {
        Chooser,
    },
}
